/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BonusType {
    CRYPTO_REWARD = 'CryptoReward',
    EXCHANGE_CASHBACK_REWARD = 'ExchangeCashbackReward',
    REAL_MONEY = 'RealMoney',
    TRADE_MONEY = 'TradeMoney',
    TRADING_CONDITIONS = 'TradingConditions',
    REBATE_REAL_MONEY = 'RebateRealMoney',
    REBATE_TRADE_MONEY = 'RebateTradeMoney',
    CRYPTO_MONEY = 'CryptoMoney',
    CRYPTO_REBATE = 'CryptoRebate',
    OTHER = 'Other',
}
